module.exports = __webpack_public_path__ + "static/img/experience_reflection.8cf14c7a.png";